import { useMutation } from '@tanstack/react-query'

import { API_PATH } from './constants'
import { http } from '../../services'
import Cookies from 'js-cookie'

export const useFreshchatRestoreIdMutation = () => {
  return useMutation({
    mutationFn: async (restoreId: string) => {
      await http.patch(API_PATH, {
        value: restoreId,
      })
      Cookies.set('app_user_freshchat_restoreId', restoreId)
    },
  })
}
